// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3AD7_","bigColWidth":"Table_bigColWidth__1VeRz","biggerColWidth":"Table_biggerColWidth__ErMkC","row":"Table_row__1uqOA","col":"Table_col__3jGNQ"};